import { Partner } from 'src/api/@generated/backend';

class PartnerUtils {
  public static getPartnerByPartnerId(partners: Partner[], partnerId: string): Partner | undefined {
    return partners.find((partner) => partner.id === partnerId);
  }
}

export { PartnerUtils };
